<template>
  <component v-if="status" :is="component" @update="onUpdate" @showTitleOnHeader="onShowTitleOnHeader" @reset="onReset">
    <slot></slot>
  </component>
</template>

<script>
import status from '@/config/status'

export default {
  name: 'BiometricView',
  data: function () {
    return {
      photoModal: false,
      reset: false
    }
  },
  computed: {
    status: function () {
      return this.$store.getters['auth/biometricStatus']
    },
    years: function () {
      return this.$store.getters['auth/years']
    },
    isInfant: function () {
      if (this.years && (this.years < 3)) {
        return true
      }
      return false
    },
    view: function () {
      if (this.isInfant) {
        return 'BiometricInfant'
      }
      let s = this.status
      if (s === status.ERROR && this.reset) {
        s = status.NOT_CONFIGURED
      }
      switch (s) {
        case status.NOT_CONFIGURED:
          return 'BiometricConfig'
        case status.PENDING_PARENTS:
          return 'BiometricConfigChild'
        case status.IN_PROCESS:
          return 'BiometricConfigPending'
        case status.FINISHED:
          return 'BiometricConfigDone'
        case status.ERROR:
          return 'BiometricConfigError'
        default:
          return 'BiometricConfig'
      }
    },
    component: function () {
      const view = this.view
      return () => import('@/views/' + view + '.vue')
    }
  },
  created: function () {
    this.fetchStatus()
  },
  methods: {
    fetchStatus: async function () {
      try {
        this.$store.commit('app/setLoading', true)
        this.$store.dispatch('auth/downloadBiometricStatus')
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    onUpdate: function () {
      this.fetchStatus()
    },
    onShowTitleOnHeader: function (val, title) {
      this.$emit('showTitleOnHeader', val, title)
    },
    onReset: function () {
      this.reset = true
    }
  }
}
</script>

<style lang="scss" scoped></style>
